import React, { useEffect, useState } from 'react';
import MessageList from 'utils/messageList';
import Route from 'enum/route.enum';
import DeviceData from 'drivers/deviceData';
import Service from 'services';
import { Navigate } from 'react-router-dom';
import { redirectTo } from 'components/common/navigation/redirect';
import ErrorDisplay from 'components/common/error/ErrorDisplay';
import environment from 'utils/environment';

const ServerDown = () => {
  const [errorMessage] = useState({
    msgType: MessageList.serverErrorMsg,
    msgTitle: !environment.isDemoMode() ? MessageList.serverisdown : MessageList.demoData,
  });
  const [redirectToLoading, setRedirectToLoading] = useState(false);

  useEffect(() => {
    let intervalId = null;

    const checkDevice = async () => {
      const getUID = await DeviceData.getUID();
      const getIP = await DeviceData.getIP();
      try {
        const res = await Service.DevicesService.getRegisterDeviceVerification(getUID, getIP);
        if (res) {
          setRedirectToLoading(true);
          if (intervalId) clearInterval(intervalId);
        }
      } catch (err) {
        if (err.status === 400 || err.status === 403 || err.status === 500 || err.status === 412) {
          if (window.location.pathname !== Route.route.DEVICEIPNOTFOUND) {
            redirectTo(Route.route.DEVICEIPNOTFOUND);
          }
        }
        console.log('checkDeviceAndProxy error', err);
      }
    };

    // Initial check
    checkDevice();

    // Set up interval
    intervalId = setInterval(checkDevice, 30000);

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, []); // No dependencies needed now

  return (
    <>
      {!redirectToLoading ? (
        <ErrorDisplay
          message={errorMessage.msgTitle}
          title='Server Error'
          icon='🔌'
          overlay={true}
        />
      ) : (
        <Navigate to={Route.route.LOADING}></Navigate>
      )}
    </>
  );
};

export default ServerDown;
